import { Navigate, Route, Routes } from "react-router-dom";

import { routes } from "../core/routes/routes";
import { Appointments, Dashboard, Dependants, Profile } from "./";

export const PageRoutes = () => {
  return (
    <Routes>
      <Route path={routes.profile.path} element={<Profile />} />
      <Route path={routes.appointments.path} element={<Appointments />} />
      <Route path={routes.family.path} element={<Dependants />} />
      <Route path={routes.dashboard.path} element={<Dashboard />} />
      <Route
        path="*"
        element={
          <Navigate to={routes.profile.subRoutes.profileDetails.fullPath} />
        }
      />
    </Routes>
  );
};
